// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease forwards;
}

/* Simple fade-in for the modal backdrop */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.feedback-modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  text-align: center;
  animation: slideDown 0.3s ease forwards;
}

/* Slight slide-down for the modal content */
@keyframes slideDown {
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.feedback-modal-content h2 {
  margin: 0 0 15px;
}

/* Circular Cancel (X) button at top-right */
.cancel-feedback {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  background-color: #0056b3;
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cancel-feedback:hover {
  background-color: #004494;
}

/* Star rating styling */
.star-rating {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
}

.star-rating button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 2rem;
  padding: 5px;
}

.star-rating button.on .star {
  color: gold;
}

.star-rating button.off .star {
  color: #ccc;
}

/* Textarea styling */
.feedback-modal-content textarea {
  width: 100%;
  height: 80px;
  padding: 10px;
  margin: 0 auto 10px auto;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  display: block;
  box-sizing: border-box;
  resize: none;
}

.error-textarea {
  border: 1px solid red !important;
}

/* Character count text */
.char-count {
  text-align: right;
  font-size: 0.8rem;
  color: #666;
  margin-top: -8px;
  margin-bottom: 10px;
}

/* Inline error messages */
.error-message {
  color: red;
  margin-bottom: 10px;
  font-size: 0.9rem;
}

/* Submit button */
.submit-feedback {
  width: auto;
  padding: 10px 20px;
  background: #0056b3;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
}

.submit-feedback:hover {
  background: #004494;
}

/* Success message styling */
.feedback-success h2 {
  color: #0056b3;
  margin-bottom: 10px;
}

.feedback-success p {
  font-size: 0.95rem;
  color: #333;
}

/* Responsive adjustments for smaller screens */
@media (max-width: 480px) {
  .feedback-modal-content {
    width: 95%;
    padding: 15px;
  }
  
  .cancel-feedback {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }
  
  .star-rating button {
    font-size: 1.5rem;
    padding: 4px;
  }
  
  .feedback-modal-content textarea {
    height: 70px;
    font-size: 0.9rem;
  }
  
  .submit-feedback {
    padding: 8px 16px;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FeedbackModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oCAAoC;AACtC;;AAEA,0CAA0C;AAC1C;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,4CAA4C;AAC5C;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":[".feedback-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n  animation: fadeIn 0.3s ease forwards;\n}\n\n/* Simple fade-in for the modal backdrop */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.feedback-modal-content {\n  background: #fff;\n  padding: 20px;\n  border-radius: 12px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  position: relative;\n  text-align: center;\n  animation: slideDown 0.3s ease forwards;\n}\n\n/* Slight slide-down for the modal content */\n@keyframes slideDown {\n  from { transform: translateY(-20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.feedback-modal-content h2 {\n  margin: 0 0 15px;\n}\n\n/* Circular Cancel (X) button at top-right */\n.cancel-feedback {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 32px;\n  height: 32px;\n  background-color: #0056b3;\n  color: #fff;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cancel-feedback:hover {\n  background-color: #004494;\n}\n\n/* Star rating styling */\n.star-rating {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 15px;\n}\n\n.star-rating button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 2rem;\n  padding: 5px;\n}\n\n.star-rating button.on .star {\n  color: gold;\n}\n\n.star-rating button.off .star {\n  color: #ccc;\n}\n\n/* Textarea styling */\n.feedback-modal-content textarea {\n  width: 100%;\n  height: 80px;\n  padding: 10px;\n  margin: 0 auto 10px auto;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  display: block;\n  box-sizing: border-box;\n  resize: none;\n}\n\n.error-textarea {\n  border: 1px solid red !important;\n}\n\n/* Character count text */\n.char-count {\n  text-align: right;\n  font-size: 0.8rem;\n  color: #666;\n  margin-top: -8px;\n  margin-bottom: 10px;\n}\n\n/* Inline error messages */\n.error-message {\n  color: red;\n  margin-bottom: 10px;\n  font-size: 0.9rem;\n}\n\n/* Submit button */\n.submit-feedback {\n  width: auto;\n  padding: 10px 20px;\n  background: #0056b3;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.submit-feedback:hover {\n  background: #004494;\n}\n\n/* Success message styling */\n.feedback-success h2 {\n  color: #0056b3;\n  margin-bottom: 10px;\n}\n\n.feedback-success p {\n  font-size: 0.95rem;\n  color: #333;\n}\n\n/* Responsive adjustments for smaller screens */\n@media (max-width: 480px) {\n  .feedback-modal-content {\n    width: 95%;\n    padding: 15px;\n  }\n  \n  .cancel-feedback {\n    width: 28px;\n    height: 28px;\n    font-size: 0.8rem;\n  }\n  \n  .star-rating button {\n    font-size: 1.5rem;\n    padding: 4px;\n  }\n  \n  .feedback-modal-content textarea {\n    height: 70px;\n    font-size: 0.9rem;\n  }\n  \n  .submit-feedback {\n    padding: 8px 16px;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
